export const FISCAL_ACTION_PERMISSIONS = [
    { key: 'FISCAL_VIEW', label: 'Фискализация: просмотр чеков' },
    { key: 'FISCAL_SEND', label: 'Фискализация: подготовка и отправка чеков' },
    { key: 'FISCAL_REFUND', label: 'Фискализация: возвраты' },
    { key: 'FISCAL_EXTERNAL_CONFIRM', label: 'Фискализация: подтверждение внешнего чека' },
    { key: 'FISCAL_RECONCILE', label: 'Фискализация: сверка результатов' },
    { key: 'FISCAL_SHIFT_MANAGE', label: 'Фискализация: управление сменами ККТ' },
    { key: 'FISCAL_PAYMENT_MANAGE', label: 'Фискализация: регистрация оплат' },
    { key: 'FISCAL_SETTINGS_MANAGE', label: 'Фискализация: юрлица, подключения и маршруты' },
    { key: 'FISCAL_TEST', label: 'Фискализация: тестовый контур' },
]

export function hasFiscalPermission(user = {}, permission) {
    if (String(user.role || '').toUpperCase() === 'SA') return true
    if (user.id && Object.prototype.hasOwnProperty.call(user, 'id_parent') && Number(user.id_parent) === 0) return true
    return Array.isArray(user.accessPage) && user.accessPage.includes(permission)
}
